import {getUpRefUid} from '../helpers/upRefCookieHelpers';

const ARM_QUERY_KEYS        = ['arm', 'exp_arm'],
      SEATCHAMP_HOST_REGEX  = /(^|\.)seatchamp\./iu;

class MigrationContext {
	resolve() {
		const {hostname, searchParams} = new URL(window.location.href);

		return {
			'distinct_id'   : getUpRefUid(),
			'experiment_arm': this._resolveArm(hostname, searchParams),
			'landing_domain': hostname,
			'source'        : this._resolveSource(searchParams),
			'session_id'    : searchParams.get('session_id') || null
		};
	}

	_resolveArm(hostname, searchParams) {
		for (const key of ARM_QUERY_KEYS) {
			const value = searchParams.get(key);

			if (value) {
				return value;
			}
		}

		return SEATCHAMP_HOST_REGEX.test(hostname) ? 'seatchamp' : 'legacy';
	}

	_resolveSource(searchParams) {
		if (searchParams.get('utm_source')) {
			return searchParams.get('utm_source');
		}

		if (searchParams.get('gclid')) {
			return 'google-ads';
		}

		if (searchParams.get('fbclid')) {
			return 'facebook-ads';
		}

		return 'direct';
	}
}

export default new MigrationContext();